// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    export enum TaxTypes {
  SalesTax = 0,
  UseTax = 1,
  BOTax = 2,
  NoTax = 3,
  HST = 4,
  PST = 5,
  GeneralTax = 6,
}
